import { average, prominent } from 'color.js';
window.colorjs = {};
window.colorjs.average = average;
window.colorjs.prominent = prominent;